import { createFileRoute } from "@tanstack/react-router";
import { SuperuserWorkspacesPage } from "@/features/superuser/workspaces/superuser-workspaces.page";

export const Route = createFileRoute("/_authenticated/superuser/workspaces")({
  component: SuperuserWorkspacesPage,
});
